export default function createProductFeatures() {
    let featuresInterval;

    const FEATURES_SELECTOR = '[data-product-features]';
    const FEATURE_SELECTOR = '[data-product-features-feature]';
    const FEATURE_ACTIVE_SELECTOR = '[data-product-features-feature="active"]';

    const featuresIntervalDelay = 7000;
    const $features = $(FEATURES_SELECTOR);

    const setProductFeatureActive = $elements => {
        const $allFeatures = $elements.find(FEATURE_SELECTOR);
        const $activeFeature = $elements.find(FEATURE_ACTIVE_SELECTOR);
        const currentIndex = $activeFeature.parent().index();
        const nextIndex = currentIndex === 2 ? 0 : currentIndex + 1;

        $activeFeature.attr('data-product-features-feature', '');

        $allFeatures.eq(nextIndex).attr('data-product-features-feature', 'active');
    };

    const getNewFeaturesInterval = ($features, delay) => {
        return window.setInterval(setProductFeatureActive, delay, $features);
    };

    const clearInterval = interval => {
        window.clearInterval(interval);
    };

    const handleMouseEnter = e => {
        $features.find(FEATURE_ACTIVE_SELECTOR).attr('data-product-features-feature', '');

        clearInterval(featuresInterval);
    };

    const handleMouseLeave = e => {
        featuresInterval = getNewFeaturesInterval($features, featuresIntervalDelay);
        setProductFeatureActive($features);
    };

    // Handle mouse events on product features
    $features.on('mouseenter', handleMouseEnter).on('mouseleave', handleMouseLeave);

    // Immediately start interval
    featuresInterval = getNewFeaturesInterval($features, featuresIntervalDelay);
    setProductFeatureActive($features);
}



// WEBPACK FOOTER //
// ./js/marketing/components/product-features.js